module.exports = __webpack_public_path__ + "img/logo2.d80b085d.png";